import moment from "moment";

const getCardDateFormat = (date: string): string => moment(String(date)).format("DD/MM/YY");

export {
  getCardDateFormat,
};